import { parseDateElastic } from 'app/shared/utils/utils';

export class SearchResult {
  static fromObject(object) {
    let date = null;
    if (object.publish_on) {
      date = parseDateElastic(object.publish_on);
    }

    let pdfId = '';
    if (object.pdf_id) {
      pdfId = object.pdf_id;
    }


    let content = object.content || object.description || '';
    if (content) {
      content = content.slice(0, 100);
      content = content.substr(0, content.lastIndexOf(' ')).concat(' ...');
    }

    let category = '';
    if (object.category_id && object.category_id.name) {
      category = object.category_id.name;
    }

    return new SearchResult(
      object.slug,
      object.title,
      content,
      date,
      object.type,
      object.newspaper_id.subname,
      pdfId,
      category
    );
  }

  constructor(
    public slug: string,
    public title: string,
    public content: string,
    public publishOn: Date,
    public type: string,
    public newspaperSubname: string,
    public pdfId?: string,
    public category?: string
  ) {}
}
